import {OrdersApi} from '@shipwell/corrogo-sdk';
import {configuration} from './configuration';

const ordersApi = new OrdersApi(configuration);

type GetOrdersListParameters = Parameters<typeof ordersApi.listOrders>;
export type GetOrdersListParametersObject = {
  status?: GetOrdersListParameters[0];
  orderNumber?: GetOrdersListParameters[1];
  supplierName?: GetOrdersListParameters[2];
  customerName?: GetOrdersListParameters[3];
  shipFromAddress?: GetOrdersListParameters[4];
  shipFromCompanyName?: GetOrdersListParameters[5];
  shipFromRegion?: GetOrdersListParameters[6];
  shipToAddress?: GetOrdersListParameters[7];
  shipToCompanyName?: GetOrdersListParameters[8];
  shipToRegion?: GetOrdersListParameters[9];
  page?: GetOrdersListParameters[10];
  limit?: GetOrdersListParameters[11];
  q?: GetOrdersListParameters[12];
  orderBy?: GetOrdersListParameters[13];
  id?: GetOrdersListParameters[14];
  idIn?: GetOrdersListParameters[15];
  statusIn?: GetOrdersListParameters[16];
  orderNumberContains?: GetOrdersListParameters[17];
  orderNumberIcontains?: GetOrdersListParameters[18];
  orderNumberIn?: GetOrdersListParameters[19];
  name?: GetOrdersListParameters[20];
  nameContains?: GetOrdersListParameters[21];
  nameIcontains?: GetOrdersListParameters[22];
  nameIn?: GetOrdersListParameters[23];
  createdAt?: GetOrdersListParameters[24];
  createdAtGte?: GetOrdersListParameters[25];
  createdAtLte?: GetOrdersListParameters[26];
  references?: GetOrdersListParameters[27];
  referencesContains?: GetOrdersListParameters[28];
  referencesIcontains?: GetOrdersListParameters[29];
  referencesIn?: GetOrdersListParameters[30];
  referencesPurchaseOrderNumber?: GetOrdersListParameters[31];
  referencesPurchaseOrderNumberContains?: GetOrdersListParameters[32];
  referencesPurchaseOrderNumberIcontains?: GetOrdersListParameters[33];
  referencesPurchaseOrderNumberIn?: GetOrdersListParameters[34];
  purchaseOrderNumber?: GetOrdersListParameters[35];
  purchaseOrderNumberContains?: GetOrdersListParameters[36];
  purchaseOrderNumberIcontains?: GetOrdersListParameters[37];
  purchaseOrderNumberIn?: GetOrdersListParameters[38];
  shipToCompanyNameContains?: GetOrdersListParameters[39];
  shipToCompanyNameIcontains?: GetOrdersListParameters[40];
  shipToCompanyNameIn?: GetOrdersListParameters[41];
  shipToRegionContains?: GetOrdersListParameters[42];
  shipToRegionIcontains?: GetOrdersListParameters[43];
  shipToRegionIn?: GetOrdersListParameters[44];
  shipToPlanWindowStartGte?: GetOrdersListParameters[45];
  shipToPlanWindowStartLte?: GetOrdersListParameters[46];
  shipToPlanWindowEndGte?: GetOrdersListParameters[47];
  shipToPlanWindowEndLte?: GetOrdersListParameters[48];
  shipToAddressIcontains?: GetOrdersListParameters[49];
  shipFromCompanyNameContains?: GetOrdersListParameters[50];
  shipFromCompanyNameIcontains?: GetOrdersListParameters[51];
  shipFromCompanyNameIn?: GetOrdersListParameters[52];
  shipFromRegionContains?: GetOrdersListParameters[53];
  shipFromRegionIcontains?: GetOrdersListParameters[54];
  shipFromRegionIn?: GetOrdersListParameters[55];
  shipFromPlanWindowStartGte?: GetOrdersListParameters[56];
  shipFromPlanWindowStartLte?: GetOrdersListParameters[57];
  shipFromPlanWindowEndGte?: GetOrdersListParameters[58];
  shipFromPlanWindowEndLte?: GetOrdersListParameters[59];
  shipFromAddressIcontains?: GetOrdersListParameters[60];
  supplierNameContains?: GetOrdersListParameters[61];
  supplierNameIcontains?: GetOrdersListParameters[62];
  supplierNameIn?: GetOrdersListParameters[63];
  customerNameContains?: GetOrdersListParameters[64];
  customerNameIcontains?: GetOrdersListParameters[65];
  customerNameIn?: GetOrdersListParameters[66];
  releasesReleasedOntoShipmentId?: GetOrdersListParameters[67];
  releasesReleasedOntoShipmentIdContains?: GetOrdersListParameters[68];
  releasesReleasedOntoShipmentIdIcontains?: GetOrdersListParameters[69];
  releasesReleasedOntoShipmentIdIn?: GetOrdersListParameters[70];
  options?: GetOrdersListParameters[71];
};

export async function getOrdersList({
  status,
  orderNumber,
  supplierName,
  customerName,
  shipFromAddress,
  shipFromCompanyName,
  shipFromRegion,
  shipToAddress,
  shipToCompanyName,
  shipToRegion,
  page,
  limit,
  q,
  orderBy,
  id,
  idIn,
  statusIn,
  orderNumberContains,
  orderNumberIcontains,
  orderNumberIn,
  name,
  nameContains,
  nameIcontains,
  nameIn,
  createdAt,
  createdAtGte,
  createdAtLte,
  references,
  referencesContains,
  referencesIcontains,
  referencesIn,
  referencesPurchaseOrderNumber,
  referencesPurchaseOrderNumberContains,
  referencesPurchaseOrderNumberIcontains,
  referencesPurchaseOrderNumberIn,
  purchaseOrderNumber,
  purchaseOrderNumberContains,
  purchaseOrderNumberIcontains,
  purchaseOrderNumberIn,
  shipToCompanyNameContains,
  shipToCompanyNameIcontains,
  shipToCompanyNameIn,
  shipToRegionContains,
  shipToRegionIcontains,
  shipToRegionIn,
  shipToPlanWindowStartGte,
  shipToPlanWindowStartLte,
  shipToPlanWindowEndGte,
  shipToPlanWindowEndLte,
  shipToAddressIcontains,
  shipFromCompanyNameContains,
  shipFromCompanyNameIcontains,
  shipFromCompanyNameIn,
  shipFromRegionContains,
  shipFromRegionIcontains,
  shipFromRegionIn,
  shipFromPlanWindowStartGte,
  shipFromPlanWindowStartLte,
  shipFromPlanWindowEndGte,
  shipFromPlanWindowEndLte,
  shipFromAddressIcontains,
  supplierNameContains,
  supplierNameIcontains,
  supplierNameIn,
  customerNameContains,
  customerNameIcontains,
  customerNameIn,
  releasesReleasedOntoShipmentId,
  releasesReleasedOntoShipmentIdContains,
  releasesReleasedOntoShipmentIdIcontains,
  releasesReleasedOntoShipmentIdIn,
  options
}: GetOrdersListParametersObject = {}) {
  const axiosResponse = await ordersApi.listOrders(
    status,
    orderNumber,
    supplierName,
    customerName,
    shipFromAddress,
    shipFromCompanyName,
    shipFromRegion,
    shipToAddress,
    shipToCompanyName,
    shipToRegion,
    page,
    limit,
    q,
    orderBy,
    id,
    idIn,
    statusIn,
    orderNumberContains,
    orderNumberIcontains,
    orderNumberIn,
    name,
    nameContains,
    nameIcontains,
    nameIn,
    createdAt,
    createdAtGte,
    createdAtLte,
    references,
    referencesContains,
    referencesIcontains,
    referencesIn,
    referencesPurchaseOrderNumber,
    referencesPurchaseOrderNumberContains,
    referencesPurchaseOrderNumberIcontains,
    referencesPurchaseOrderNumberIn,
    purchaseOrderNumber,
    purchaseOrderNumberContains,
    purchaseOrderNumberIcontains,
    purchaseOrderNumberIn,
    shipToCompanyNameContains,
    shipToCompanyNameIcontains,
    shipToCompanyNameIn,
    shipToRegionContains,
    shipToRegionIcontains,
    shipToRegionIn,
    shipToPlanWindowStartGte,
    shipToPlanWindowStartLte,
    shipToPlanWindowEndGte,
    shipToPlanWindowEndLte,
    shipToAddressIcontains,
    shipFromCompanyNameContains,
    shipFromCompanyNameIcontains,
    shipFromCompanyNameIn,
    shipFromRegionContains,
    shipFromRegionIcontains,
    shipFromRegionIn,
    shipFromPlanWindowStartGte,
    shipFromPlanWindowStartLte,
    shipFromPlanWindowEndGte,
    shipFromPlanWindowEndLte,
    shipFromAddressIcontains,
    supplierNameContains,
    supplierNameIcontains,
    supplierNameIn,
    customerNameContains,
    customerNameIcontains,
    customerNameIn,
    releasesReleasedOntoShipmentId,
    releasesReleasedOntoShipmentIdContains,
    releasesReleasedOntoShipmentIdIcontains,
    releasesReleasedOntoShipmentIdIn,
    options
  );
  return axiosResponse.data;
}
